// extracted by mini-css-extract-plugin
module.exports = {"link":"_1m4fG","ShinyButtonInverted":"_27y68","shinyButtonInverted":"_27y68","labelwrapper":"_22UYF","label":"_9SBwT"};